import { chatConstants } from '../../constants'
import { chatService } from '../../services'
import { alertActions } from '../'
import { errorMessages } from '../../messages'

export const chatActions = {
  send,
  receive,
  load,
  toggle,
  delete: _delete
}

function send(username, password) {
  return dispatch => {
    dispatch(request({ username }))

    chatService.send(username, password)
    .then(
      response => {
        dispatch(success(response))
      },
      error => {
        dispatch(failure(error))
        dispatch(alertActions.error({
          title: null,
          message: errorMessages.systemError
        }))
      }
    )
  }
  function request(response) {
    return {
      type: chatConstants.SEND_REQUEST,
      response
    }
  }
  function success(response) {
    return {
      type: chatConstants.SEND_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: chatConstants.SEND_FAILURE,
      response
    }
  }
}

function receive() {
  return { type: chatConstants.RECEIVE_REQUEST }
}

function toggle(types) {
  return { type: chatConstants[types] }
}

function load() {
  return dispatch => {
    dispatch(request())

    chatService.load()
    .then(
      response => {
        dispatch(success(response))
      },
      error => {
        dispatch(failure(error))
        dispatch(alertActions.error({
          title: null,
          message: errorMessages.systemError
        }))
      }
    )
  }

  function request() {
    return {
      type: chatConstants.LOAD_REQUEST
    }
  }
  function success(response) {
    return {
      type: chatConstants.LOAD_SUCCESS,
      response
    }
  }
  function failure(error) {
    return {
      type: chatConstants.LOAD_FAILURE, error
    }
  }
}

function _delete(id) {
  return dispatch => {
    dispatch(request(id))

    chatService.delete(id)
    .then(
      user => {
        dispatch(success(id))
      },
      error => {
        dispatch(failure(id, error))
      }
    )
  }

  function request(id) {
    return {
      type: chatConstants.DELETE_REQUEST,
      id
    }
  }
  function success(id) {
    return {
      type: chatConstants.DELETE_SUCCESS,
      id
    }
  }
  function failure(id, error) {
    return {
      type: chatConstants.DELETE_FAILURE,
      id,
      error
    }
  }
}
